import React from 'react';
import { FadeIn } from './FadeIn';
import { ClockIcon } from 'lucide-react';
export function OpeningHook() {
  return <section className="py-16 px-6 border-y border-slate-800 bg-[#14B8A5]" data-id="element-127">
      <div className="max-w-3xl mx-auto" data-id="element-128">
        <FadeIn data-id="element-129">
          <div className="relative pl-8 md:pl-12 border-l-4 border-teal-500 py-2" data-id="element-130">
            <ClockIcon className="absolute left-[-22px] top-0 w-10 h-10 text-teal-500 bg-navy-800 rounded-full p-1 border-4 border-navy-800" data-id="element-131" />
            <p className="text-xl md:text-2xl text-slate-200 leading-relaxed font-serif italic" data-id="element-132">
              "Estás en medio de una reunión, conduciendo o atendiendo a tu
              familia cuando aparece esa punzada familiar detrás del ojo. Sabes
              lo que viene: horas de agonía, náuseas y la necesidad desesperada
              de una habitación oscura."
            </p>
            <p className="mt-6 text-lg text-slate-400 leading-relaxed bg-[#5F1414]" data-id="element-133">
              Pero hoy es martes, tienes entregas pendientes y el mundo no se
              detiene porque a ti te duela la cabeza. Tomar otra pastilla solo
              te dejará sedado o te dará un "efecto rebote" mañana.{' '}
              <strong className="text-white font-semibold" data-id="element-134">
                Necesitas una solución que funcione ahora mismo.
              </strong>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}